if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

// You can use this exception to wrap and throw fetch responses that are non-200
function ResponseException(response) {
    this.response = response;

    this.resolveResponse = function () {
        return new Promise(function (resolve, reject) {
            response.text().then(resolve).catch(reject);
        });
    };
}

// You can use this exception to wrap and throw unsuccessful ajax call responses
function AjaxException(responseText, statusCode) {
    // raw http response text
    this.responseText = responseText;
    // http response code
    this.statusCode = statusCode;
    // short error type text for json responses. Ex: 'Cart Error'
    this.message = this.responseText;
    // longer error description for json responses. Ex: 'You can't add more {productTitle} to the cart.'
    this.description = '';
    // message and description put together
    this.longMessage = this.message;

    try {
        const decodedResponse = JSON.parse(responseText);
        this.message = decodedResponse.message || (decodedResponse.description ? (decodedResponse.error || '') : '');
        if (!this.message && decodedResponse.errors && typeof decodedResponse.errors === 'string') {
            this.message = decodedResponse.errors;
        }
        this.description = decodedResponse.description || decodedResponse.error || '';
    } catch (e) {
        console.log(e);
    }

    this.longMessage = [this.message, this.description].filter(Boolean).join(' - ');
}

/** @var BryanAnthonys */

BryanAnthonys.getCookie = function (name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }

    return null;
};

BryanAnthonys.makePostConfig = function (type = 'json') {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/' + type
        }
    };
};

BryanAnthonys.getPageQueryParam = function (paramName) {
    let params = new URLSearchParams(window.location.search);

    return params.has(paramName) ? params.get(paramName) : null;
};

BryanAnthonys.resizeImage = function (imageUrl, width, height = null, crop = null, format = null) {
    if (imageUrl.indexOf('//') === 0) {
        imageUrl = 'https:' + imageUrl;
    }
    let newImageUrl = new URL(imageUrl);
    newImageUrl.searchParams.set('width', parseInt(width).toString());
    if (height) {
        newImageUrl.searchParams.set('height', parseInt(height).toString());
    }
    if (crop && ['center', 'top', 'center', 'bottom', 'left', 'right'].indexOf(crop) !== -1) {
        newImageUrl.searchParams.set('crop', crop);
    }
    if (format && ['png', 'jpg'].indexOf(format) !== -1) {
        newImageUrl.searchParams.set('format', format);
    }

    return newImageUrl.toString();
};

BryanAnthonys.validateEmail = function (email) {
    return /\S+@\S+\.\S+/.test(email);
};

BryanAnthonys.escapeHtml = function (unsafe) {
    if (!unsafe || typeof unsafe !== 'string') {
        return '';
    }

    return unsafe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
};

BryanAnthonys.htmlReviewedForSafety = function (html) {
    // For now, using this method is simply a mean to confirm that you checked the HTML you are
    // about to insert into the DOM via unsafe methods, for any potential issues.
    return html;
};

/**
 * WARNING:
 * This method should not be relied upon to completely sanitize html. It's a simple backup method that
 * could catch and fix some issues that slipped through other checks.
 * It may, or it may not help, it may have limitations when dealing with complex or malformed HTML,
 * or scripts that are obfuscated or encoded in a non-standard way
 */
BryanAnthonys.partiallySanitize = function (html) {
    if (!html || typeof html !== 'string') {
        return '';
    }

    const eventAttributes = [
        'onafterprint', 'onbeforeprint', 'onbeforeunload', 'onerror', 'onhashchange', 'onload', 'onmessage', 'onoffline',
        'ononline', 'onpagehide', 'onpageshow', 'onpopstate', 'onresize', 'onstorage', 'onunload',
        'onblur', 'onchange', 'oncontextmenu', 'onfocus', 'oninput', 'oninvalid', 'onreset', 'onsearch', 'onselect', 'onsubmit',
        'onkeydown', 'onkeypress', 'onkeyup', 'ontoggle',
        'onclick', 'ondblclick', 'ondrag', 'ondragend', 'ondragenter', 'ondragleave', 'ondragover', 'ondragstart', 'ondrop',
        'onmousedown', 'onmousemove', 'onmouseout', 'onmouseover', 'onmouseup', 'onmousewheel', 'onscroll', 'onwheel',
        'oncopy', 'oncut', 'onpaste',
        'onabort', 'oncanplay', 'oncanplaythrough', 'oncuechange', 'ondurationchange', 'onemptied', 'onended', 'onerror',
        'onloadeddata', 'onloadedmetadata', 'onloadstart', 'onpause', 'onplay', 'onplaying', 'onprogress', 'onratechange',
        'onseeked', 'onseeking', 'onstalled', 'onsuspend', 'ontimeupdate', 'onvolumechange', 'onwaiting'
    ];

    const attributeRegex = new RegExp('\\b(' + eventAttributes.join('|') + ')\\b', 'gi');

    html = html.replace(attributeRegex, '');

    const scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*(<\/script>|$)/gi;

    return html.replace(scriptRegex, '');
};

BryanAnthonys.handleize = function (string) {
    return string.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};

BryanAnthonys.dollarsToCents = function (priceString) {
    return Math.round(parseFloat(priceString) * 100);
};

// eslint-disable-next-line max-lines-per-function
BryanAnthonys.formatMoney = function (cents, removeTrailingZeros = true, format = null) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    let value = '';
    let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    let formatString = (format || BryanAnthonys.moneyFormat);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        let parts = number.split('.');
        let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        let cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    const amountType = formatString.match(placeholderRegex)[1];
    switch (amountType) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    let money = formatString.replace(placeholderRegex, value);
    if (removeTrailingZeros) {
        if (amountType === 'amount_with_comma_separator') {
            money = money.replace(',00', '');
        } else {
            money = money.replace('.00', '');
        }
    }

    return money;
};

BryanAnthonys.getProductHandleFromUrl = function (url) {
    if (!url.includes('products/')) {
        return '';
    }

    return url.replace(/\/+$/, '').split('?')[0].split('/').pop();
};

BryanAnthonys.reportIssue = function (type, data, message = null, throttled = false) {
    if (!BryanAnthonys.issueReportingUrl) {
        return;
    }

    data.pageUrl = window.location.href.substring(0, 150);
    let url = new URL(BryanAnthonys.issueReportingUrl);
    url.searchParams.set('type', type);
    url.searchParams.set('data', encodeURIComponent(JSON.stringify(data)));
    if (message) {
        url.searchParams.set('message', encodeURIComponent(message.slice(0, 100)));
    }

    if (throttled && localStorage.getItem(url.toString())) {
        return;
    }

    const pixel = document.createElement('img');
    pixel.loading = 'eager';
    pixel.src = url.toString();

    localStorage.setItem(url.toString(), 1);
};

BryanAnthonys.extractReportDataFromRequestBody = function (body) {
    if (body instanceof FormData) {
        const data = {};

        ['id', 'quantity', 'sections', 'sections_url'].forEach(function (param) {
            if (body.has(param)) {
                data[param] = body.get(param);
            }
        });

        if (body.has('items')) {
            data['items'] = body.get('items');
        }

        return data;
    }

    try {
        return JSON.parse(body);
    } catch (e) {
        return {body: body};
    }
};

BryanAnthonys.getCountry = function () {
    const storedCountry = localStorage.getItem('ba.geoip.country');
    if (storedCountry) {
        return storedCountry;
    }

    if (!Shopify || !Shopify.country) {
        BryanAnthonys.reportIssue('other', '', 'Missing country in Shopify object', 'throttled');

        return 'US';
    }

    return Shopify.country.toUpperCase();
};

BryanAnthonys.isDomesticVisitor = function () {
    return BryanAnthonys.getCountry() === 'US';
};

BryanAnthonys.isInternationalVisitor = function () {
    return BryanAnthonys.getCountry() !== 'US';
};

BryanAnthonys.isEUVisitor = function () {
    const EU = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB', 'UK'];

    return EU.includes(BryanAnthonys.getCountry());
};

BryanAnthonys.updateGeolocationClasses = function() {
    if (BryanAnthonys.isDomesticVisitor()) {
        document.documentElement.classList.remove('eu-visitor', 'international-visitor');
        document.documentElement.classList.add('domestic-visitor');
    } else {
        document.documentElement.classList.remove('domestic-visitor');
        document.documentElement.classList.add('international-visitor');
        if (BryanAnthonys.isEUVisitor()) {
            document.documentElement.classList.add('eu-visitor');
        }
    }
};

BryanAnthonys.getVisitorEmail = function () {
    if (BryanAnthonys.customerEmail) {
        return BryanAnthonys.customerEmail;
    }

    const attentiveEmail = localStorage.getItem('attentive_email_save');
    if (attentiveEmail && BryanAnthonys.validateEmail(attentiveEmail)) {
        return attentiveEmail;
    }

    let baEmail = localStorage.getItem('baem_save');
    if (baEmail) {
        baEmail = atob(baEmail).trim();
        if (BryanAnthonys.validateEmail(baEmail)) {
            return baEmail;
        }
    }

    return null;
};

BryanAnthonys.rememberVisitorEmail = function (email) {
    if (!BryanAnthonys.validateEmail(email)) {
        return;
    }

    localStorage.setItem('baem_save', btoa(email));

    document.dispatchEvent(new CustomEvent('rememberedVisitorEmail', {
        detail: {email: email}
    }));
};

BryanAnthonys.getVisitorInfo = function () {
    const visitorInfo = {
        type: 'prospectVisitor',
        orderCount: 0,
        lastOrderAt: null,
        lastVisitAt: null,
        firstVisitAt: null,
        landingCampaign: null,
        lastCampaign: null,
        landingSource: null,
        lastSource: null
    };

    let storedVisitorInfo = localStorage.getItem('ba_visitor_info');
    if (storedVisitorInfo) {
        storedVisitorInfo = JSON.parse(storedVisitorInfo);
        for (let prop in storedVisitorInfo) {
            if (Object.prototype.hasOwnProperty.call(visitorInfo, prop)) {
                visitorInfo[prop] = storedVisitorInfo[prop];
            }
        }
    }

    return visitorInfo;
};

BryanAnthonys.rememberVisitorInfo = function (newVisitorInfo, existingVisitorInfo = null) {
    const visitorInfo = existingVisitorInfo || BryanAnthonys.getVisitorInfo();
    for (let prop in newVisitorInfo) {
        if (Object.prototype.hasOwnProperty.call(visitorInfo, prop)) {
            visitorInfo[prop] = newVisitorInfo[prop];
        }
    }

    localStorage.setItem('ba_visitor_info', JSON.stringify(visitorInfo));
};

BryanAnthonys.decodeJsonResponse = function (response) {
    if (!response.ok) {
        throw new ResponseException(response);
    }

    return response.json();
};

BryanAnthonys.decodeTextResponse = function (response) {
    if (!response.ok) {
        throw new ResponseException(response);
    }

    return response.text();
};

BryanAnthonys.cart = {mutators: {}, cartMutationsCount: 0};

BryanAnthonys.cart.handleError = function (exception, requestBody, rejectPromiseFn, operationType) {
    const reportData = BryanAnthonys.extractReportDataFromRequestBody(requestBody);
    if (exception instanceof ResponseException) {
        reportData.statusCode = exception.response.status;
        exception.resolveResponse().then(function (response) {
            const ajaxException = new AjaxException(response, exception.response.status);
            BryanAnthonys.reportIssue(operationType, reportData, ajaxException.longMessage);
            rejectPromiseFn(ajaxException);
        });
    } else {
        BryanAnthonys.reportIssue(operationType, reportData, String(exception));
        rejectPromiseFn(exception);
    }
};

BryanAnthonys.cart.dispatchEvent = function (eventName, request, response, eventSource) {
    document.dispatchEvent(new CustomEvent(eventName, {
        detail: {
            requestBody: request,
            response: response,
            eventSource: eventSource
        }
    }));
};

BryanAnthonys.cart.getCache = function () {
    if (BryanAnthonys.cartCache) {
        return JSON.parse(JSON.stringify(BryanAnthonys.cartCache));
    }

    let initialCartContent = document.querySelector('[data-initial-cart-content]').innerHTML;

    return JSON.parse(initialCartContent);
};

BryanAnthonys.cart.setCache = function (response) {
    if (response.sections && response.sections['cart-json']) {
        let cartJson = (new DOMParser())
            .parseFromString(response.sections['cart-json'], 'text/html')
            .querySelector('#shopify-section-cart-json').innerHTML;
        try {
            cartJson = atob(cartJson);
            BryanAnthonys.cartCache = JSON.parse(cartJson);
        } catch (error) {
            console.error('cart json section content cannot be parsed', error, cartJson);
        }
    } else if (response.items && Array.isArray(response.items)) {
        BryanAnthonys.cartCache = response;
    }
};

BryanAnthonys.cart.fetch = function () {
    return new Promise(function (resolve, reject) {
        fetch('/cart.json')
            .then(BryanAnthonys.decodeJsonResponse)
            .then(function (response) {
                BryanAnthonys.cart.setCache(response);
                resolve(response);
            })
            .catch(function (exception) {
                BryanAnthonys.cart.handleError(exception, {}, reject, 'cart_get');
            });
    });
};

BryanAnthonys.cart.add = function (body, eventSource = 'pdp') {
    const addCartJsonSection = function (body) {
        if (body instanceof FormData) {
            let sections = body.get('sections');
            body.set('sections', [sections, 'cart-json'].filter(Boolean).join(','));
        } else if (typeof body === 'string') {
            const decodedBody = JSON.parse(body);
            decodedBody.sections = [decodedBody.sections, 'cart-json'].filter(Boolean).join(',');
            body = JSON.stringify(decodedBody);
        }

        return body;
    };

    const data = BryanAnthonys.makePostConfig('javascript');
    data.headers['X-Requested-With'] = 'XMLHttpRequest';

    if (typeof body !== 'string') {
        delete data.headers['Content-Type'];
    }
    data.body = addCartJsonSection(body);

    return new Promise(function (resolve, reject) {
        fetch(BryanAnthonys.routes.cartAdd, data)
            .then(BryanAnthonys.decodeJsonResponse)
            .then(function (response) {
                BryanAnthonys.cart.setCache(response);
                BryanAnthonys.cart.dispatchEvent('itemAddedToCart', data.body, response, eventSource);
                resolve(response);
            })
            .catch(function (exception) {
                BryanAnthonys.cart.handleError(exception, data.body, reject, 'cart_add');
            });
    });
};

BryanAnthonys.cart.change = function (body, eventSource = 'cart') {
    const data = BryanAnthonys.makePostConfig();
    data.body = body;

    return new Promise(function (resolve, reject) {
        fetch(BryanAnthonys.routes.cartChange, data)
            .then(BryanAnthonys.decodeJsonResponse)
            .then(function (response) {
                BryanAnthonys.cart.setCache(response);
                BryanAnthonys.cart.dispatchEvent('changedCartItem', body, response, eventSource);
                resolve(response);
            })
            .catch(function (exception) {
                BryanAnthonys.cart.handleError(exception, body, reject, 'cart_change');
            });
    });
};

BryanAnthonys.cart.update = function (body, eventSource = 'cart') {
    const data = BryanAnthonys.makePostConfig();
    data.body = body;

    return new Promise(function (resolve, reject) {
        fetch(BryanAnthonys.routes.cartUpdate, data)
            .then(BryanAnthonys.decodeJsonResponse)
            .then(function (response) {
                BryanAnthonys.cart.setCache(response);
                BryanAnthonys.cart.dispatchEvent('updatedCart', body, response, eventSource);
                resolve(response);
            })
            .catch(function (exception) {
                BryanAnthonys.cart.handleError(exception, body, reject, 'cart_change');
            });
    });
};

/**
 * Add a mutator function that may run after the cart is rendered
 * The function should return true if it will update the cart or false otherwise
 * @param key {string}
 * @param callback {function}
 */
BryanAnthonys.cart.addMutator = function (key, callback) {
    BryanAnthonys.cart.mutators[key] = callback;
};

BryanAnthonys.cart.runMutators = function () {
    try {
        const cart = BryanAnthonys.cart.getCache();
        if (!cart.item_count || BryanAnthonys.cart.cartMutationsCount > 20) {
            return;
        }

        const mutators = BryanAnthonys.cart.mutators;
        for (const key in mutators) {
            const changesCart = mutators[key](cart);

            if (changesCart) {
                BryanAnthonys.cart.cartMutationsCount++;
                console.log(`${key} mutator is automatically updating the cart`);

                break;
            }
        }
    } catch (error) {
        // As soon as a mutator throws an error we must stop running the other mutators
        // because a situation could exist where the mutator that threw the error actually did update the cart.
        // That means that the subsequent mutators would run against an outdated cart, opening the possibility for update loops
        console.error(error);
    }
};

BryanAnthonys.productsCache = {};
BryanAnthonys.getProduct = function (handle, template) {
    if (typeof template === 'undefined' || ['standard-json', 'full-json'].indexOf(template) === -1) {
        template = 'standard-json';
    }

    return new Promise(function (resolve, reject) {
        const cacheKey = template + '.' + handle;
        if (BryanAnthonys.productsCache[cacheKey]) {
            resolve(BryanAnthonys.productsCache[cacheKey]);

            return;
        }

        fetch('/products/' + handle + '?view=' + template)
            .then(function (response) {
                return response.text();
            })
            .then(function (html) {
                BryanAnthonys.productsCache[cacheKey] = JSON.parse(html);
                resolve(BryanAnthonys.productsCache[cacheKey]);
            })
            .catch(reject);
    });
};

BryanAnthonys.device = {};

BryanAnthonys.device.hasTouchscreen = function () {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
};

BryanAnthonys.device.isMobile = function () {
    return window.matchMedia('(max-width: 749px)').matches;
};

BryanAnthonys.debounce = function (func, wait) {
    let timeout = null;

    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            timeout = null;
            func.apply(context, args);
        }, wait || 0);
    };
};

/**
 * minimumVisibileArea must be a value between 0 and 1. It describes how much of the element must
 * be visible in order to be considered in viewport. A minimumVisibleArea of 1 means that the element
 * must be entirely in viewport while 0.5 means that at least half of the element must be visible
 */
BryanAnthonys.isElementInViewport = function (element, minimumVisibileArea = 1) {
    const bounding = element.getBoundingClientRect();
    let notVisibleAreaY = 0;
    let notVisibleAreaX = 0;
    if (minimumVisibileArea < 1) {
        notVisibleAreaY = element.offsetHeight * (1 - minimumVisibileArea);
        notVisibleAreaX = element.offsetWidth * (1 - minimumVisibileArea);
    }

    return bounding.top >= -notVisibleAreaY
        && bounding.left >= -notVisibleAreaX
        && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + notVisibleAreaX
        && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + notVisibleAreaY;
};

BryanAnthonys.showToast = function (message, type = 'info', visibleMiliseconds = 7000) {
    document.querySelectorAll('toast-banner').forEach(toast => toast.remove());

    const id = `toast-banner-${Math.round(Math.random() * 100000)}`;
    const toast = document.createElement('div');
    toast.id = id;
    toast.className = 'toast-banner';
    const toastMessage = document.createElement('div');
    toastMessage.className = `status-banner status-banner--${type} pl-3 pr-5`;
    toastMessage.innerText = message;

    toastMessage.insertAdjacentHTML('afterbegin', BryanAnthonys.htmlReviewedForSafety(`
        <div class="toast-progress" style="--transition-duration: ${parseInt(visibleMiliseconds)}ms">&nbsp;</div>
        <button type="button" class="toast-remove" aria-label="Remove toast">
            <svg class="icon icon-close" aria-hidden="true" focusable="false"><use href="#icon-close"/></svg>
        </button>
    `));

    toast.appendChild(toastMessage);
    document.body.appendChild(toast);
    setTimeout(
        () => toast.querySelector('.toast-progress').classList.add('toast-progress--empty'),
        100
    );

    const removeToast = () => {
        const toast = document.getElementById(id);
        if (toast) {
            toast.remove();
        }
    };

    setTimeout(removeToast, visibleMiliseconds);
    toast.querySelector('button').addEventListener('click', removeToast);
};

(function () {
    // automatically update visitor info
    const visitorInfo = BryanAnthonys.getVisitorInfo();
    const newVisitorInfo = {};
    const now = Date.now();
    const source = BryanAnthonys.getPageQueryParam('utm_source');
    const campaign = BryanAnthonys.getPageQueryParam('utm_campaign');

    if (!visitorInfo.firstVisitAt) {
        newVisitorInfo.firstVisitAt = now;
        newVisitorInfo.landingCampaign = campaign;
        newVisitorInfo.landingSource = source;
    }

    if (source && source !== visitorInfo.lastSource) {
        newVisitorInfo.lastSource = BryanAnthonys.escapeHtml(source);
    }
    if (campaign && campaign !== visitorInfo.lastCampaign) {
        newVisitorInfo.lastCampaign = BryanAnthonys.escapeHtml(campaign);
    }

    newVisitorInfo.lastVisitAt = now;

    if (BryanAnthonys.customerId) {
        newVisitorInfo.orderCount = BryanAnthonys.customerOrdersCount;
        newVisitorInfo.type = newVisitorInfo.orderCount > 0 ? 'existingCustomer' : 'prospectCustomer';
        newVisitorInfo.lastOrderAt = BryanAnthonys.customerLastOrderAt ? (parseInt(BryanAnthonys.customerLastOrderAt) * 1000) : null;
    }

    BryanAnthonys.rememberVisitorInfo(newVisitorInfo, visitorInfo);

    document.addEventListener('DOMContentLoaded', function () {
        const countryStorageKey = 'ba.geoip.country';
        const brokenStorageKey = 'ba.geoip.broken';
        if (localStorage.getItem(countryStorageKey)) {
            // other means of detection already worked
            return;
        }

        if (localStorage.getItem(brokenStorageKey)){
            // if previous ip api calls failed we no longer make calls
            return;
        }

        fetch('https://pro.ip-api.com/json/?fields=country,countryCode&key=Pyj44AGgZvXdkbD')
            .then(function (response) {
                if (!response.ok) {
                    localStorage.setItem(brokenStorageKey, true);
                    throw response;
                }

                return response.json();
            })
            .then(function (response) {
                const countryCode = response.countryCode.toUpperCase();
                localStorage.setItem(countryStorageKey, countryCode);
                if (countryCode !== 'US') {
                    BryanAnthonys.updateGeolocationClasses();
                }
            });
    });

    document.addEventListener('subscribedToNewsletter', function (event) {
        const emailAddress = event.detail.body.get('email');
        if (emailAddress && BryanAnthonys.validateEmail(emailAddress)) {
            BryanAnthonys.rememberVisitorEmail(emailAddress);
        }
    });
})();
(function () {
    if (!('visualViewport' in window)) {
        return;
    }

    let bodyHasZoomedClass = false;
    function toggleVisualViewportZoomBodyClass() {
        const isZoomed = window.visualViewport.scale > 1.01;
        if (isZoomed && !bodyHasZoomedClass) {
            document.body.classList.add('body--visual-viewport-zoomed');
            bodyHasZoomedClass = true;
        } else if (!isZoomed) {
            document.body.classList.remove('body--visual-viewport-zoomed');
            bodyHasZoomedClass = false;
        }
    }

    window.visualViewport.addEventListener('resize', toggleVisualViewportZoomBodyClass);
    document.addEventListener('DOMContentLoaded', toggleVisualViewportZoomBodyClass);
})();